import { Injectable } from "@angular/core";
import { ConfigHelper } from "../../app/helpers/configHelper";
import { PesquisaDados, PesquisaLinkResponse, PesquisaSatisfacao } from "../../app/models/PesquisaModel";
import { HttpProvider } from "../http/http";

@Injectable()
export class PesquisaProvider {

    urlApi = ConfigHelper.UrlPesquisaV1;

    constructor(private httpSrv: HttpProvider){

    }

    async getPesquisasConcessionaria(codConcessionaria: number): Promise<PesquisaDados> {

        try {
            let urlConn = this.urlApi + "pesquisas_criadas/"+codConcessionaria+"/0";
            let ResultConn = await this.httpSrv.curlPost(urlConn, null, null, 10, 1, 'Buscando pesquisas...', 300000);
            if(ResultConn.success){
                // console.log("data ", ResultConn.data)
                return <PesquisaDados>ResultConn.data;
            }

        } catch(error) {
            console.log('problema ao carregar as busca pesquisa online', error);
        }

    }

    async createPesquisaLink(codPesquisa: string, dados: PesquisaSatisfacao): Promise<PesquisaLinkResponse> {

        try {
            
            let formData = new FormData();
            for (var key in dados) {
                formData.append(key, dados[key]);
            }

            let urlConn = this.urlApi + "pesquisa_link_gerar/"+codPesquisa;
            let ResultConn = await this.httpSrv.curlPostFormData(urlConn, null, formData, 10, 1, "Gerando pesquisa...", 300000);
            if(ResultConn.success){
                // console.log("data ", ResultConn.data)
                return <PesquisaLinkResponse>ResultConn.data;
            }

        } catch(error) {
            console.log('problema ao carregar as busca pesquisa online', error);
        }

    }

}


// WEBPACK FOOTER //
// ./src/providers/pesquisa/pesquisa.ts